//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CustomBtn from '@/components/CustomBtn';
export default {
  components: {
    CustomBtn: CustomBtn
  },
  props: {
    showIKnow: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleClose: function handleClose() {
      console.log('关闭');
      this.$emit('handleClose');
    }
  }
};